require("./components/min");

$(function() {
  $("body").on("click touchstart", ".to-clipboard", function() {
    copyTextToClipboard($(this).data("clipboard"), this);
  });

  function changeText(target) {
    target.innerHTML = "Copied to clipboard";

    setTimeout(() => {
      target.innerHTML = "Share link";
    }, 1000);
  }

  function fallbackCopyTextToClipboard(text, target) {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand("copy");
    } catch (err) {
      console.error("Fallback: Oops, unable to copy", err);
    }

    document.body.removeChild(textArea);
    changeText(target);
  }

  function copyTextToClipboard(text, target) {
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(text, target);
      return;
    }
    navigator.clipboard.writeText(text).then(
      function() {},
      function(err) {
        console.error("Async: Could not copy text: ", err);
      }
    );

    changeText(target);
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const controlNext = document.getElementById("testimonial-control-next");
  const controlPrev = document.getElementById("testimonial-control-prev");

  controlNext.addEventListener("click", () => {
    const offset = window.innerWidth > 500 ? 42 : 44;
    // 42 px is the gap

    const sliderContent = document.getElementById("slider-content");
    sliderContent.scroll(
      sliderContent.scrollLeft + sliderContent.clientWidth + offset,
      0
    );
  });

  controlPrev.addEventListener("click", () => {
    const offset = window.innerWidth < 500 ? 42 : 44;
    const sliderContent = document.getElementById("slider-content");
    sliderContent.scroll(
      sliderContent.scrollLeft + -sliderContent.clientWidth - offset,
      0
    );
  });
});
